<template>
  <div id="app">
    <mainLoading />
    <main
      :style="$store.state.utils.loaded ? 'display: block' : 'display: none'"
    >
      <mainNotifications />
      <!-- <div id="elNavbar"></div> -->
      <router-view />
      <!-- <a href="#" class="btn btn-top"
        ><i class="fa fa-arrow-up" aria-hidden="true"></i
      ></a> -->
      <!-- <div id="elFooter"></div> -->
    </main>
  </div>
</template>

<script>
import Vue from "vue";

import elNavbar from "./components/Navbar.vue";
import elFooter from "./components/Footer.vue";
import mainLoading from "./components/Loading.vue";
import mainNotifications from "./components/Notifications.vue";

export default {
  name: "App",
  metaInfo() {
    if (!localStorage.details || localStorage.details == undefined) {
      this.$store.state.utils.cookies = true;
    } else {
      this.$store.state.utils.cookies = false;
    }

    return {
      htmlAttrs: {
        lang: "en-US",
        dir: "ltr",
      },
    };
  },

  components: {
    mainLoading,
    mainNotifications,
  },

  data() {
    return { vue_viewer: null };
  },

  created() {},

  watch: {
    "$route.fullPath"(val) {
      // this.loadStaticElements();
    },
  },

  mounted() {
    this.$nextTick(() => {
      !this.$route.name
        ? this.$router.push({
            name: "NotFound",
            params: { error: this.$route.fullPath },
          })
        : (this.$store.state.utils.loaded = true);
      // : this.loadStaticElements();
    });
  },

  methods: {
    async loadStaticElements() {
      document.querySelector("#elNavbar").innerHTML = "";
      document.querySelector("#elFooter").innerHTML = "";

      await this.buildStaticElement(elNavbar, "#elNavbar");
      await this.buildStaticElement(elFooter, "#elFooter");

      document.body.onscroll = await this.scrollNavbar;

      this.$store.state.utils.loaded = true;
    },

    async buildStaticElement(el, location) {
      const element = Vue.extend(el);
      const component = await new element({ parent: this }).$mount();
      document.querySelector(location).appendChild(component.$el);
    },

    scrollNavbar() {
      const top = document.body.scrollTop || document.documentElement.scrollTop;

      let navigate = document.querySelector("#main_nav.navbar");
      if (navigate) {
        if (top > 30) {
          navigate.classList.add("fix-top-navbar");
        } else {
          navigate.classList.remove("fix-top-navbar");
        }
      }

      let topButton = document.querySelector(".btn-top");
      if (topButton) {
        if (top > 100) {
          topButton.style.display = "block";
        } else {
          topButton.style.display = "none";
        }
      }
    },
  },

  destroyed() {},
};
</script>

<style lang="scss">
/*
Template Name: Doot - Responsive Bootstrap 5 Chat App
Author: Themesbrand
Version: 1.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Main Css File
*/

//Fonts
// @import "custom/fonts/fonts";

//Core files
@import "./node_modules/bootstrap/scss/functions";
@import "./node_modules/bootstrap/scss/variables";
@import "bootstrap";
@import "variables";
@import "./node_modules/bootstrap/scss/mixins.scss";

// Components
@import "custom/components/waves";
@import "custom/components/avatar";
@import "custom/components/helper";
@import "custom/components/preloader";
@import "custom/components/accordion";
@import "custom/components/modals";
@import "custom/components/forms";


// Plugins
@import "custom/plugins/custom-scrollbar";
@import "custom/plugins/emoji-picker";

// structure
@import "custom/structure/general";
@import "custom/structure/sidemenu";

// Pages
@import "custom/pages/chat-leftsidebar";
@import "custom/pages/user-chat";
@import "custom/pages/user-profile-details";
@import "custom/pages/authentication";


</style>
